import { EditorDef } from "bvd3";

const editorDef: EditorDef = {
    sections: [
        {
            title: "Control",
            id: "control",
            layout: "single-page",
            view: {
                type: "list",
                items: [],
            },
        },
    ],
};

export default editorDef;



// WEBPACK FOOTER //
// ./app/javascript/pipeline-flowchart/editor.ts